module.exports = __webpack_public_path__ + "static/media/dc-healthy.35f3a0c2.svg";